import { css } from 'styled-components'

/**
 * Focus outline mix-in. Apply to a styled component to render the standard
 * focus ring (primary.200 outline + md border-radius).
 *
 * The optional `offset` argument forwards to `outline-offset` (in px) — use a
 * negative value to draw the ring inside the element's bounds.
 *
 * Usage:
 *   const MyComponent = styled(Box)`
 *     ${(p) => p.$isFocused && focusOutline()}
 *   `
 *
 *   // with inset ring:
 *   ${(p) => p.$isFocused && focusOutline(-2)}
 */
export const focusOutline = (offset?: number) => css`
  outline: 2px solid ${(p) => p.theme.colors.primary['200']};
  border-radius: ${(p) => p.theme.radiuses.md}px;
  ${offset !== undefined ? `outline-offset: ${offset}px;` : ''}
`
